import { render, staticRenderFns } from "./layer_3.vue?vue&type=template&id=33d11d5c&scoped=true"
import script from "./layer_3.vue?vue&type=script&lang=js"
export * from "./layer_3.vue?vue&type=script&lang=js"
import style0 from "./layer_3.vue?vue&type=style&index=0&id=33d11d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d11d5c",
  null
  
)

export default component.exports